export default {
	inject: {
		$validator: '$validator'
	},
	$_veeValidate: {
		value() {
			return this.selected;
		},
		name() {
			return this.name;
		},
	},
	props: {
		value: {
			required: true,
		},
		name: {
			type: String,
			required: true,
		},
		placeholder: {
			type: String,
			default: 'Select...',
		},
		multiple: {
			type: Boolean,
			default: false,
		},
		allowEmpty: {
			type: Boolean,
			default: true,
		}
	},
	data() {
		return {
			options: [],
			selected: this.multiple ? [] : null,
		}
	},
	methods: {
		setValue(value) {
			if(this.multiple) {
				let selected = Array.isArray(value) ? value : value;

				this.selected = this.options.filter(option => selected.indexOf(option.id) > -1);
			} else {
				this.selected = this.options.filter(option => option.id === value).shift();
			}
		},
		setInitialValue() {
			this.setValue(this.value);
		},
        clearValue: function() {
            this.selected = this.multiple ? [] : null;
        }
	},
	watch: {
		value(value) {
			if(!this.selected) {
				this.setValue(value);
			}
		},
		selected(selected) {
			if(Array.isArray(selected)) {
				this.$emit('input', selected.filter(selected => selected).map(item => item.id));
			} else {
				this.$emit('input', selected ? selected.id : null);
			}
		},
	},
	created() {
		this.setInitialValue();
	}
}
